import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';

/** `/templates` (1.S): the layout of the templates pages, guarded as `/` is. */
export const Route = createFileRoute('/templates')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  staticData: { crumb: 'Templates' },
  component: Outlet,
});
